// extracted by mini-css-extract-plugin
export default {"wAx":"matlab_wAx__m+i+v","hamArz":"matlab_hamArz__v8uSQ"};